import updateCacheAccount from './user/updateCacheAccount';
import { commandeResolvers } from './commande/commande.resolvers';

export const resolvers = {
  Mutation: {
    ...updateCacheAccount,
    ...commandeResolvers
  }
};
